import { ImageResponse } from '../types/api/image-response'
import { Image } from '../types/models/image.model'

export function imageResolver(image: ImageResponse[]): Image[]
export function imageResolver(image: ImageResponse): Image

export function imageResolver(
  image: ImageResponse | ImageResponse[],
): Image | Image[] {
  if (Array.isArray(image)) {
    return image.map(i => ({
      id: i.id,
      url: i.original_url,
      preview: i.preview_url,
    }))
  }
  return {
    id: image.id,
    url: image.original_url,
    preview: image.preview_url,
  }
}
